
import Shot from '@/components/XShot/Shot'
import Qrcode from 'vux/src/components/qrcode/index.vue'

import WechatShare from '@/components/WechatShare/WechatShare'
export default {
name: 'hotView',
data() {
return {
print: {},
pageIndex: 1,
pageSize: 50
}
},
computed: {
live() {
return this.$store.state.live.detail
},
list() {
return this.$store.state.live.largePhotoList
},
url() {
return `https://yun.aiyaopai.com/live/${this.$route.params.liveId}`
}
},
methods: {
shot(item) {
this.print = item
this.$refs.shot.init()
setTimeout(() => {
// 设置qrcode宽高
this.$refs.qrcode.$el.querySelector('img').style.width = '56px'
this.$refs.qrcode.$el.querySelector('img').style.height = '56px'
}, 200)
}
},
components: {
Shot,
Qrcode,
WechatShare
},
mounted() {
setTimeout(() => {
this.$vux.loading.hide()
}, 1000)

// window.removeEventListener('scroll', this.fn_scroll, false)
this.$store.dispatch({
type: 'getLiveDetail',
liveId: this.$route.params.liveId,
router: this.$router
})
let options = {
isLarge: true,
liveId: this.$route.params.liveId,
pageIndex: this.pageIndex,
pageSize: this.pageSize
}

this.$store.dispatch({
type: 'getLargePhotoList',
option: options
})
}
}



// WEBPACK FOOTER //
// ./src/pages/live/HotView.vue